'use client';

import { HelpCircle, Book, MessageCircle, Video, Shield, ArrowLeft } from 'lucide-react';
import Link from 'next/link';

export default function CitizenHelpPage() {
 return (
 <div className="min-h-screen bg-gradient-to-b from-zinc-900 to-black text-neutral-200 font-sans selection:bg-emerald-500/30">
 <div className="p-8 pt-16">
 {/* Back Link */}
 <Link
 href="/citizen"
 className="inline-flex items-center gap-2 text-zinc-400 hover:text-emerald-400 transition-colors mb-8"
 >
 <ArrowLeft size={16} />
 Back to Citizen Portal
 </Link>

 {/* Header */}
 <div className="mb-8">
 <div className="flex items-center gap-3 mb-2">
 <HelpCircle className="h-8 w-8 text-emerald-400"/>
 <h1 className="text-3xl font-bold text-white">Citizen Help Center</h1>
 </div>
 <p className="text-neutral-400 mt-1">Get help with reporting, video calls, and your account</p>
 </div>

 {/* Help Cards */}
 <div className="grid gap-4 md:grid-cols-2">
 <div className="border border-white/10 rounded-2xl bg-white/5 backdrop-blur-sm p-6 hover:border-emerald-500/50 transition-colors">
 <div className="w-12 h-12 bg-emerald-500/10 rounded-xl flex items-center justify-center mb-4">
 <Video className="h-6 w-6 text-emerald-400"/>
 </div>
 <h3 className="text-lg font-semibold text-white mb-2">How to Join a Call</h3>
 <p className="text-neutral-400 text-sm mb-4">
 Enter your call ID or paste the invite link you received from an officer.
 You can join with or without creating an account.
 </p>
 </div>

 <div className="border border-white/10 rounded-2xl bg-white/5 backdrop-blur-sm p-6 hover:border-blue-500/50 transition-colors">
 <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center mb-4">
 <Shield className="h-6 w-6 text-blue-400"/>
 </div>
 <h3 className="text-lg font-semibold text-white mb-2">Anonymous Reports</h3>
 <p className="text-neutral-400 text-sm mb-4">
 Submit reports without creating an account. Your identity remains protected
 while still allowing you to provide important information.
 </p>
 </div>

 <div className="border border-white/10 rounded-2xl bg-white/5 backdrop-blur-sm p-6 hover:border-violet-500/50 transition-colors">
 <div className="w-12 h-12 bg-violet-500/10 rounded-xl flex items-center justify-center mb-4">
 <Book className="h-6 w-6 text-violet-400"/>
 </div>
 <h3 className="text-lg font-semibold text-white mb-2">Creating an Account</h3>
 <p className="text-neutral-400 text-sm mb-4">
 Create an account to track your reports, receive updates, and access
 your submission history from any device.
 </p>
 </div>

 <div className="border border-white/10 rounded-2xl bg-white/5 backdrop-blur-sm p-6 hover:border-amber-500/50 transition-colors">
 <div className="w-12 h-12 bg-amber-500/10 rounded-xl flex items-center justify-center mb-4">
 <MessageCircle className="h-6 w-6 text-amber-400"/>
 </div>
 <h3 className="text-lg font-semibold text-white mb-2">Contact Support</h3>
 <p className="text-neutral-400 text-sm mb-4">
 Need additional help? Contact your local agency directly or speak
 with an officer during your scheduled call.
 </p>
 </div>
 </div>

 {/* FAQ Section */}
 <div className="mt-8 border border-white/10 rounded-2xl bg-white/5 backdrop-blur-sm p-8">
 <h2 className="text-xl font-semibold text-white mb-6">Frequently Asked Questions</h2>

 <div className="space-y-6">
 <div>
 <h3 className="text-white font-medium mb-2">What do I need for a video call?</h3>
 <p className="text-neutral-400 text-sm">
 You need a device with a camera and microphone (smartphone, tablet, or computer),
 a stable internet connection, and a modern web browser like Chrome, Firefox, or Safari.
 </p>
 </div>

 <div>
 <h3 className="text-white font-medium mb-2">Is my information secure?</h3>
 <p className="text-neutral-400 text-sm">
 Yes. All communications are encrypted, and your personal information is protected
 according to applicable privacy laws and our security policies.
 </p>
 </div>

 <div>
 <h3 className="text-white font-medium mb-2">Can I remain anonymous?</h3>
 <p className="text-neutral-400 text-sm">
 Yes. You can submit anonymous reports without creating an account.
 However, if you want to track your report status, you&apos;ll need to create an account.
 </p>
 </div>
 </div>
 </div>
 </div>
 </div>
 );
}
